var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FormUsersAFY, ModalAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
import { ModalUiProps } from "../../constanst/adminUsersDTO";
export var CreateUser = function (props) {
    var _a, _b, _c, _d;
    return (_jsx(ModalAFY, __assign({}, ModalUiProps, { title: props.isEdit ? "Editar Usuario" : "Crear Usuario", name: "".concat(props.dataFormUsers.names, " ").concat(props.dataFormUsers.lastNames), openModal: props.openModal, onClose: function () {
            props.setOpenModal(false);
        } }, { children: _jsx(FormUsersAFY, { typeList: (_a = props.identificationTypesList) !== null && _a !== void 0 ? _a : [], genderList: (_b = props.genderList) !== null && _b !== void 0 ? _b : [], branchList: (_c = props.listBranch) !== null && _c !== void 0 ? _c : [], companyList: (_d = props.companyList) !== null && _d !== void 0 ? _d : [], dataFormUsers: props.dataFormUsers, isReadOnly: props.isEdit, isEdit: props.isEdit, onClickCancel: function () {
                props.setOpenModal(false);
            }, onNext: function (e) { return props.handleSubmitUser(e); } }) })));
};
